// extracted by mini-css-extract-plugin
module.exports = {"ai-container":"AiDataLake_ai-container__PzWiN"};